import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

export * from './snackbar.service';

export const TM_SNACK_BAR_PROVIDER = {
  provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
  useValue: { duration: 3000, verticalPosition: 'top', horizontalPosition: 'right' }
};